import { h } from "preact";

import classname from "../../../../foundation/utils/classname";
import PopoverWithHover, { PopoverWithHoverProps } from "../../Popover/PopoverWithHover";
import Popover, { PopoverProps } from "../../Popover";
import Teyze, { TeyzeProps } from "../Teyze";
import { TeyzeImageSize } from "..";

import styles from "./TeyzeTooltip.module.css";

type InheritedPopoverProps = Omit<PopoverProps & PopoverWithHoverProps, "content">;
type InheritedTeyzeContentProps = Omit<TeyzeProps, "ninja" | "contentClass">;

type Props = InheritedTeyzeContentProps & InheritedPopoverProps & {
    withHover?: boolean;
};

const DEFAULT_PADDING = 8; // px
const DEFAULT_SCROLL_CONTAINER_PADDING = {
    top: DEFAULT_PADDING,
    right: DEFAULT_PADDING,
    bottom: DEFAULT_PADDING,
    left: DEFAULT_PADDING
};

function TeyzeTooltip({
    class: cssClass,
    // Teyze props
    text,
    variant,
    link,
    innerLink,
    imageSize = TeyzeImageSize.Small,
    onLinkClick,
    // Popover props
    withHover = false,
    scrollContainerOptions = {},
    closeOnDocumentClick = false,
    closeOnEscape = false,
    onClose,
    ...popoverProps
}: Props) {
    function renderContent() {
        return (
            <Teyze
                ninja
                text={text}
                variant={variant}
                link={link}
                innerLink={innerLink}
                imageSize={imageSize}
                onLinkClick={onLinkClick}/>
        );
    }

    const PopoverComponent = withHover ? PopoverWithHover : Popover;

    return (
        <PopoverComponent
            {...popoverProps}
            class={classname(styles.teyzeTooltip, cssClass)}
            contentClass={classname(styles.teyzeTooltipPopoverContent, { [styles.hasCloseButton]: !!onClose })}
            content={renderContent()}
            scrollContainerOptions={{
                padding: scrollContainerOptions.padding ?? DEFAULT_SCROLL_CONTAINER_PADDING,
                ...scrollContainerOptions
            }}
            closeOnDocumentClick={closeOnDocumentClick}
            closeOnEscape={closeOnEscape}
            showCloseButton={!!onClose}
            onClose={onClose}/>
    );
}

export default TeyzeTooltip;
export {
    Props as TeyzeTooltipProps
};
